var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyprEdgeLogoWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 56,
    viewBox: "0 0 275 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    fill: "#282876"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7163 11.7161C38.1087 11.7714 38.4256 11.8734 38.7309 12.0454C39.3675 12.4096 39.6728 12.905 39.8094 13.8026C39.8443 14.0474 39.917 15.1431 39.9373 15.7551C39.9926 17.3695 40.0216 26.6248 39.9809 29.3933C39.9548 31.235 39.9257 31.8324 39.8385 32.2492C39.5507 33.6246 38.7396 34.63 37.3965 35.277C36.7308 35.5946 36.1144 35.7811 35.6813 35.7869C35.0795 35.7957 34.9923 35.6354 34.7307 34.088C34.5708 33.1351 34.5591 33.2137 34.9022 33.1555C35.1929 33.1088 36.0301 32.8174 36.2365 32.695C36.7308 32.3978 37.0593 31.8703 37.161 31.1971C37.1872 31.0369 37.193 28.8279 37.1872 22.6616L37.1786 14.4677C37.1785 14.3923 37.1306 14.3253 37.0593 14.3009V14.3009C36.9459 14.2601 36.9343 14.263 36.5796 14.4C36.2831 14.5166 33.0445 16.1572 30.0269 17.7221C28.2245 18.6546 26.0994 19.7416 25.8959 19.829C25.4656 20.0185 25.2331 20.0126 24.954 19.8086C24.8261 19.7183 24.7563 19.6192 24.4278 19.0685C24.2185 18.7188 24.0295 18.3778 24.0063 18.3137C23.8929 17.9902 24.0121 17.6726 24.3609 17.3753C24.5557 17.2092 24.8028 17.0781 27.082 15.9357C29.8787 14.534 33.53 12.7535 34.3295 12.398C35.7307 11.7743 36.6988 11.582 37.7163 11.7161ZM21.009 11.9783C21.1573 12.0395 21.2125 12.1648 21.1922 12.3863C21.1834 12.4854 21.1689 12.905 21.1602 13.3218C21.1515 13.7385 21.1369 14.1348 21.1282 14.2018V14.2018C21.1199 14.2733 21.0594 14.3271 20.9875 14.3271H20.9043C20.1136 14.33 19.349 14.9974 18.9798 16.0173C18.8112 16.4894 18.7967 16.6206 18.692 18.8295C18.5321 22.1487 18.5176 22.7141 18.5176 25.1678C18.5176 27.6244 18.5467 28.4782 18.692 30.355C18.7909 31.6751 18.849 31.9403 19.163 32.5056C19.3432 32.8291 19.5351 33.0418 19.7444 33.1438C19.8927 33.2167 19.9392 33.2254 20.1863 33.2225C20.416 33.2196 20.5003 33.2021 20.695 33.1292C20.8229 33.0826 20.9857 33.0098 21.0584 32.969C21.5672 32.6834 29.4368 28.7347 30.5386 28.2101C31.1985 27.8983 31.4485 27.8488 31.809 27.9595C32.1142 28.0557 32.2509 28.1752 32.6608 28.7085C32.8875 29.0057 33.0213 29.2592 33.0445 29.4487C33.0794 29.7401 32.8904 30.0869 32.5765 30.3025C32.4166 30.4132 25.3464 33.9539 24.6051 34.2949C23.8929 34.6242 23.6429 34.7524 23.0789 35.0788C22.0701 35.6645 21.2881 35.8918 20.288 35.8918C19.0496 35.8918 18.1455 35.5217 17.3344 34.6854C17.0466 34.3881 16.8082 34.0414 16.6076 33.6334C16.3925 33.1904 16.2878 32.8699 16.1774 32.322C15.9942 31.4186 16 31.6634 16 23.7981C16 19.3366 16.0116 16.5331 16.0291 16.3525C16.1134 15.4724 16.3431 14.7235 16.721 14.094C17.4536 12.8788 18.6223 12.1153 20.0293 11.9375C20.3142 11.9026 20.884 11.9259 21.009 11.9783ZM33.53 19.7766C33.7306 19.8786 33.8382 20.0243 33.969 20.3653C34.0359 20.5401 34.1812 20.8344 34.2917 21.018C34.6493 21.6213 34.658 21.9127 34.3207 22.1633C34.2481 22.2187 33.5329 22.5858 32.7335 22.9822C31.9311 23.3785 29.5502 24.5675 27.4396 25.6253C25.329 26.6831 23.512 27.5836 23.3987 27.6302C23.0702 27.7614 22.8027 27.7381 22.5178 27.5486C22.3957 27.467 21.8899 26.7706 21.7387 26.4791C21.634 26.281 21.6253 26.2402 21.6282 26.042C21.6282 25.8555 21.6428 25.7972 21.7213 25.6486C21.8404 25.4184 21.9655 25.2843 22.1806 25.1474C22.4742 24.958 32.8323 19.7795 33.0067 19.7329C33.1928 19.6833 33.3817 19.7008 33.53 19.7766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 5.58472C34.3957 9.43971 34.7133 9.43971 33.3563 9.43971C31.9992 9.43971 32.3176 9.43971 32.3176 5.58472C32.3176 1.72974 32.0303 1.72974 33.357 1.72974C34.6822 1.72974 34.3957 1.72974 34.3957 5.58472Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 5.58472C29.2532 9.43971 29.5707 9.43971 28.2138 9.43971C26.8566 9.43971 27.175 9.43971 27.175 5.58472C27.175 1.72974 26.8877 1.72974 28.2144 1.72974C29.5396 1.72974 29.2532 1.72974 29.2532 5.58472Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 5.58472C29.2532 9.43971 29.5707 9.43971 28.2138 9.43971C26.8566 9.43971 27.175 9.43971 27.175 5.58472C27.175 1.72974 26.8877 1.72974 28.2144 1.72974C29.5396 1.72974 29.2532 1.72974 29.2532 5.58472Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 5.58472C29.2532 9.43971 29.5707 9.43971 28.2138 9.43971C26.8566 9.43971 27.175 9.43971 27.175 5.58472C27.175 1.72974 26.8877 1.72974 28.2144 1.72974C29.5396 1.72974 29.2532 1.72974 29.2532 5.58472Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 5.58472C29.2532 9.43971 29.5707 9.43971 28.2138 9.43971C26.8566 9.43971 27.175 9.43971 27.175 5.58472C27.175 1.72974 26.8877 1.72974 28.2144 1.72974C29.5396 1.72974 29.2532 1.72974 29.2532 5.58472Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 5.58472C24.1106 9.43971 24.4281 9.43971 23.0712 9.43971C21.714 9.43971 22.0325 9.43971 22.0325 5.58472C22.0325 1.72974 21.7451 1.72974 23.0718 1.72974C24.397 1.72974 24.1106 1.72974 24.1106 5.58472Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3957 41.4766C34.3957 45.3316 34.7133 45.3316 33.3563 45.3316C31.9992 45.3316 32.3176 45.3316 32.3176 41.4766C32.3176 37.6216 32.0303 37.6216 33.357 37.6216C34.6822 37.6216 34.3957 37.6216 34.3957 41.4766Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 41.4766C29.2532 45.3316 29.5707 45.3316 28.2138 45.3316C26.8566 45.3316 27.175 45.3316 27.175 41.4766C27.175 37.6216 26.8877 37.6216 28.2144 37.6216C29.5396 37.6216 29.2532 37.6216 29.2532 41.4766Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 41.4766C29.2532 45.3316 29.5707 45.3316 28.2138 45.3316C26.8566 45.3316 27.175 45.3316 27.175 41.4766C27.175 37.6216 26.8877 37.6216 28.2144 37.6216C29.5396 37.6216 29.2532 37.6216 29.2532 41.4766Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 41.4766C29.2532 45.3316 29.5707 45.3316 28.2138 45.3316C26.8566 45.3316 27.175 45.3316 27.175 41.4766C27.175 37.6216 26.8877 37.6216 28.2144 37.6216C29.5396 37.6216 29.2532 37.6216 29.2532 41.4766Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 41.4766C29.2532 45.3316 29.5707 45.3316 28.2138 45.3316C26.8566 45.3316 27.175 45.3316 27.175 41.4766C27.175 37.6216 26.8877 37.6216 28.2144 37.6216C29.5396 37.6216 29.2532 37.6216 29.2532 41.4766Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 41.4766C24.1106 45.3316 24.4281 45.3316 23.0712 45.3316C21.714 45.3316 22.0325 45.3316 22.0325 41.4766C22.0325 37.6216 21.7451 37.6216 23.0718 37.6216C24.397 37.6216 24.1106 37.6216 24.1106 41.4766Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7622C13.4239 17.7622 13.4239 17.4419 13.4239 18.811C13.4239 20.1804 13.4239 19.8591 9.56887 19.8591C5.71387 19.8591 5.71387 20.149 5.71387 18.8103C5.71387 17.4732 5.71387 17.7622 9.56887 17.7622Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7622C13.4239 17.7622 13.4239 17.4419 13.4239 18.811C13.4239 20.1804 13.4239 19.8591 9.56887 19.8591C5.71387 19.8591 5.71387 20.149 5.71387 18.8103C5.71387 17.4732 5.71387 17.7622 9.56887 17.7622Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7622C13.4239 17.7622 13.4239 17.4419 13.4239 18.811C13.4239 20.1804 13.4239 19.8591 9.56887 19.8591C5.71387 19.8591 5.71387 20.149 5.71387 18.8103C5.71387 17.4732 5.71387 17.7622 9.56887 17.7622Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 17.7622C13.4239 17.7622 13.4239 17.4419 13.4239 18.811C13.4239 20.1804 13.4239 19.8591 9.56887 19.8591C5.71387 19.8591 5.71387 20.149 5.71387 18.8103C5.71387 17.4732 5.71387 17.7622 9.56887 17.7622Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 22.9515C13.4239 22.9515 13.4239 22.6311 13.4239 24.0002C13.4239 25.3696 13.4239 25.0483 9.56887 25.0483C5.71387 25.0483 5.71387 25.3382 5.71387 23.9995C5.71387 22.6625 5.71387 22.9515 9.56887 22.9515Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56887 28.1407C13.4239 28.1407 13.4239 27.8203 13.4239 29.1894C13.4239 30.5588 13.4239 30.2375 9.56887 30.2375C5.71387 30.2375 5.71387 30.5275 5.71387 29.1888C5.71387 27.8517 5.71387 28.1407 9.56887 28.1407Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 17.7625C50 17.7625 50 17.4421 50 18.8112C50 20.1806 50 19.8593 46.1431 19.8593C42.2861 19.8593 42.2861 20.1493 42.2861 18.8106C42.2861 17.4735 42.2861 17.7625 46.1431 17.7625Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 22.9515C50 22.9515 50 22.6311 50 24.0002C50 25.3696 50 25.0483 46.1431 25.0483C42.2861 25.0483 42.2861 25.3382 42.2861 23.9995C42.2861 22.6625 42.2861 22.9515 46.1431 22.9515Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 28.1407C50 28.1407 50 27.8203 50 29.1894C50 30.5588 50 30.2375 46.1431 30.2375C42.2861 30.2375 42.2861 30.5275 42.2861 29.1888C42.2861 27.8517 42.2861 28.1407 46.1431 28.1407Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4357 22.3121C33.7851 19.1741 33.5843 18.7679 34.4423 20.5038C35.3004 22.2401 35.0991 21.8327 28.7497 24.9708C22.4004 28.1088 22.5821 28.4765 21.7432 26.7791C20.9053 25.0837 21.0864 25.4502 27.4357 22.3121Z",
    fill: "#D71E74"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.551 33.9933C100.023 33.9933 99.6621 33.999 99.2748 34C98.2143 33.9933 98.0534 33.6886 98.0048 32.8961C98.0623 30.4201 98.0031 27.9422 98.0381 25.4656C98.0489 24.6946 97.8455 24.0457 97.3944 23.3666C94.6649 19.2579 92.0073 15.1127 89.2959 10.9947C88.8495 10.3168 88.811 9.96312 89.8693 10.0381C89.9225 10.0419 89.9764 10.0397 90.0299 10.0382C94.7625 9.90519 94.7336 9.91894 97.0359 13.5993C98.8254 16.4598 100.688 19.2858 102.541 22.1158C103.109 22.9833 103.437 23.8546 103.404 24.8892C103.327 27.3643 103.288 29.8462 103.416 32.3182C103.485 33.6509 103.04 33.9933 101.505 33.999C101.246 33.9582 100.971 33.9933 100.551 33.9933Z",
    fill: "#282876"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.996 15.1815C108.727 16.9103 107.503 18.5498 106.207 20.2857C105.073 19.2347 104.401 18.0043 103.533 16.8842C103.265 16.5394 103.543 16.2046 103.759 15.9002C104.99 14.1642 106.235 12.4343 107.456 10.6935C107.781 10.2311 108.189 9.98864 108.875 10.0004C110.485 10.028 112.096 10.0092 114 10.0092C112.592 11.8164 111.317 13.4543 109.996 15.1815Z",
    fill: "#D21D71"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.384 10.1374C227.138 10.9391 223.04 15.5494 223 21.8835C222.96 28.2577 227.217 33.0685 233.702 33.9103C236.367 34.2712 240.345 33.5095 242.732 32.2266L244.602 31.1843V26.4136V21.6831H242.414H240.226V25.2911C240.226 28.8591 240.226 28.9393 239.152 29.3802C238.515 29.6208 236.964 29.8613 235.611 29.8613C233.582 29.9014 232.906 29.701 231.275 28.6987C228.49 26.9749 227.376 24.6898 227.615 21.3624C227.774 19.3178 228.053 18.516 228.968 17.3534C231.156 14.6674 231.951 14.2666 235.611 14.2666C238.595 14.2666 239.072 14.3868 240.584 15.4291L242.255 16.5917L243.608 15.2688L245 13.9058L244.085 12.9436C242.136 10.7788 237.6 9.5761 233.384 10.1374Z",
    fill: "#282876"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 22V34H66.4327H68.8654V28.9153V23.8305H75.2788H81.6923V28.9153V34H84.3462H87L86.9115 22.0814L86.7788 10.2034H84.3462H81.9135L81.7808 14.9627L81.6481 19.7627H75.2788H68.8654V14.8814V10H66.4327H64V22Z",
    fill: "#282876"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 22.0202V34H119.391H121.782V30.5599V27.1197H125.739C130.608 27.1197 132.956 26.5936 134.999 25.0152C137.216 23.3153 137.956 21.7369 137.999 18.8229C138.042 15.2209 136.695 13.1164 133.347 11.5784C130.956 10.4452 130.478 10.3642 123.913 10.2024L117 10V22.0202ZM130.217 14.7352C132.912 15.7875 133.869 18.4587 132.478 21.0084C131.565 22.6273 130.043 23.0725 125.695 23.0725H121.782V18.6206V14.1686H125.26C127.26 14.1686 129.391 14.4115 130.217 14.7352Z",
    fill: "#282876"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 22.0202V34H145.415H147.83V30.5599V27.1197H151.036H154.285L156.832 30.5599L159.423 34H162.234H165L162.058 30.0742C160.214 27.6459 159.291 26.1079 159.643 25.9865C160.653 25.6627 162.804 23.7605 163.507 22.5464C163.902 21.8179 164.21 20.2395 164.21 18.8229C164.253 15.2209 162.892 13.1164 159.511 11.5784C157.096 10.4452 156.613 10.3642 149.982 10.2024L143 10V22.0202ZM156.349 14.7352C159.072 15.7875 160.038 18.4587 158.633 21.0084C157.754 22.5464 156.13 23.113 151.695 23.3558L147.83 23.5987V18.8634V14.1686H151.343C153.363 14.1686 155.515 14.4115 156.349 14.7352Z",
    fill: "#282876"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195 22V34H201.456C208.67 34 211.286 33.5119 214.198 31.5593C217.658 29.2407 219.261 25.7831 218.966 21.2271C218.67 16.8746 216.814 13.9864 213.016 11.8712C210.443 10.4475 207.531 10 200.907 10H195V22ZM208.375 14.5559C212.721 15.5729 215.168 20.0475 213.776 24.4407C212.552 28.4271 209.767 29.9322 203.65 29.9322H199.641V22V14.0678H203.059C204.915 14.0678 207.32 14.2712 208.375 14.5559Z",
    fill: "#282876"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 22V34H262.02H271L270.878 32.0475L270.755 30.1356L264.143 30.0136L257.49 29.9322V26.8814V23.8305H263.245H268.959L268.837 21.878L268.714 19.9661L263.122 19.8441L257.49 19.722V16.9153V14.0678H264.061H270.592L270.469 12.1153L270.347 10.2034L261.694 10.0814L253 10V22Z",
    fill: "#282876"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.453 30C188.975 30.0002 188.975 30.0002 188.975 32.0984C188.975 32.3912 188.942 32.6875 188.981 32.9762C189.082 33.7191 188.786 34.0052 187.887 33.9999C182.575 33.9687 177.262 33.9715 171.949 33.9983C171.174 34.0022 170.922 33.7565 171.02 33.1264C171.027 33.0853 171.022 33.0428 171.021 33.001C170.945 30 170.945 30 174.358 30C178.342 30 182.327 30 186.453 30Z",
    fill: "#282876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 20C184.98 20.0002 184.98 20.0002 184.98 22.0984C184.98 22.3912 184.955 22.6875 184.985 22.9762C185.064 23.7192 184.834 24.0052 184.135 23.9999C180.002 23.9687 175.87 23.9715 171.738 23.9983C171.135 24.0022 170.939 23.7565 171.016 23.1264C171.021 23.0853 171.017 23.0428 171.016 23.001C170.957 20 170.957 20 173.611 20C176.711 20 179.81 20 183.019 20Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.453 10C188.975 10.0002 188.975 10.0002 188.975 12.0984C188.975 12.3912 188.942 12.6875 188.981 12.9762C189.082 13.7191 188.786 14.0052 187.887 13.9999C182.575 13.9687 177.262 13.9715 171.949 13.9983C171.174 14.0022 170.922 13.7565 171.02 13.1264C171.027 13.0853 171.022 13.0428 171.021 13.001C170.945 10 170.945 10 174.358 10C178.342 10 182.327 10 186.453 10Z",
    fill: "#282876"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3447_60294",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3447_60294",
    x: 85,
    y: 10,
    width: 33,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3447_60294",
    x: 85,
    y: 10,
    width: 22.4229,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.725084 0 0 0 0 0.70625 0 0 0 0 0.75 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3447_60294",
    x: 99.4229,
    y: 10,
    width: 18.5771,
    height: 18.2856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.725084 0 0 0 0 0.70625 0 0 0 0 0.75 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3447_60294",
    x: 219,
    y: 10,
    width: 30,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3447_60294",
    x: 60,
    y: 10,
    width: 31,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3447_60294",
    x: 113,
    y: 10,
    width: 29,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3447_60294",
    x: 139,
    y: 10,
    width: 30,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3447_60294",
    x: 191,
    y: 10,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3447_60294",
    x: 249,
    y: 10,
    width: 26,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3447_60294",
    x: 167,
    y: 10,
    width: 26,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3447_60294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3447_60294",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyprEdgeLogoWeb);
export default __webpack_public_path__ + "static/media/HyprEdge-Logo-Web.fbe78cff909422d6907201a085765fd0.svg";
export { ForwardRef as ReactComponent };